module.exports = __webpack_public_path__ + "img/evaluate-data-export-active.58b7608b.svg";